import { AppEnv, EnvProps } from './env-types';
import { envDefaults } from './env-defaults';
import { merge } from 'lodash';

const env: EnvProps = merge(envDefaults, {
  appEnv: AppEnv.PROD,
  oidc: {
    clientId: '0oa19t2ombiA2srwS0x8',
    issuer: 'https://mlb.okta.com/oauth2/auslv3cyxpTq2DdSK0x7',
  },
  baseURL: 'https://lari-api.mlbinfra.com',
  datadog: {
    env: AppEnv.PROD,
  },
});

window.MLBBest = { env };
